<template>
  <div class="companyBox">
    <navigation></navigation>
    <div class="homeBG">
    </div>
    <div class="contenter ">
      <h1 style="text-align: center;">南京际华三五二一环保科技有限公司</h1>
      <div class="profile-content profile-content1">
        <p>
          南京际华三五二一环保科技有限公司,是南京际华三五二一特种装备有限公司的全资子公司，公司现有职工130余人，注册资本为5000万元人民币，隶属新兴际华集团，国有军工上市公司，拥有30多年丰富的滤料研发经验，是国内从事各类耐高温、耐腐蚀滤材生产的专业厂家——工业强基高温除尘先进技术应用示范单位。2021年5月，公司入选国务院国资委"双百企业"名单。
        </p>
        <p>
          公司主要产品涵盖PPS、P84、PTFE、NOMEX、ZMS及聚酯等系列滤料，以及除尘器骨架及相关备品备件，并提供专业的售后服务。耐高温、耐腐蚀滤袋及滤筒国内市场占有率排名前三，广泛应用于电力、水泥、钢铁、垃圾焚烧、碳黑、化工等行业除尘领域。
        </p>
        <p>
          公司装备与技术实力雄厚：引进德国针刺、水刺、高温/特高温定型、PTFE及玻纤等国际一流滤料生产线，建有专业化实验室、独立新产品试验线及纺织材料检测中心，配备VDI滤料动态测试仪、电子显微镜等完善检测设备；现拥有授权专利34项（其中发明专利19项）、注册商标3项，参与编制7项国家/行业/团体标准，是国内唯一两次承接国家科技部863计划项目的滤料企业，掌握先进氟处理技术，多项产品达国际先进水平。
        </p>
        <p>
          公司技术成果与奖项丰硕：2016年，"细旦聚酰亚胺纤维滤料研发及应用"获中国建筑材料协会科技进步二等奖；2017年，"节能型水刺滤料关键技术"获中国纺织行业科技进步一等奖，同年获评"高温过滤领域袋式除尘技术先进应用示范单位"，碳纤维抗电击滤料获中央企业青年创新优秀奖；2019年获"全国纺织行业质量奖"，2022年获中国纺织工业联合会"产品开发贡献奖"，为大气粉尘治理贡献突出。
        </p>
        <p>
          公司荣誉及平台资质完备：荣获全国文明单位、中央企业先进基层党组织、国有重点企业管理标杆、"十三五"领军企业等称号，获评江苏省专精特新中小企业、江苏省高新技术企业、江苏省企业技术中心，并获批组建江苏省二噁英烟气分解除尘工程技术研究中心等科研平台；同时担任中国产业用纺织品行业协会副会长单位，及中国环境保护产业协会等多协会会员单位。
        </p>
      </div>
    </div>
    <dibu></dibu>
  </div>
</template>

<script>
import navigation from '@/views/navigation.vue'
import dibu from './dibu.vue';
export default {
  name: 'CompanyProfile',
  components: {
    navigation,
    dibu
  }
}
</script>

<style lang="scss" scoped>
.companyBox {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
   position: relative;

  .homeBG {
    width: 100%;
    height: 400px;
    background-image: url('../img/wzdh.png');
    background-size: 100% 100%;

    // 大屏幕适配
    @media (min-width: 768px) {
      height: 600px;
    }

    @media (min-width: 1200px) {
      height: 800px;
    }
  }

  .contenter {
    padding-left: 20px; // 移动端内边距
    padding-right: 20px;
    padding-top: 30px;
    padding-bottom: 30px;
    font-size: 20px; // 移动端字体大小
    font-weight: 300;
    line-height: 1.6; // 增加行高提升可读性
    font-family: fangsong;

    h1 {
      font-size: 24px; // 移动端标题大小
      margin-bottom: 20px;
      line-height: 1.4;

      // 大屏幕标题适配
      @media (min-width: 768px) {
        font-size: 28px;
      }

      @media (min-width: 1200px) {
        font-size: 32px;
      }
    }

    p {
      margin-bottom: 16px;
      text-align: justify; // 两端对齐

      // 大屏幕段落适配
      @media (min-width: 768px) {
        font-size: 18px;
        margin-bottom: 18px;
      }

      @media (min-width: 1200px) {
        font-size: 22px;
        margin-bottom: 20px;
      }
    }

    // 平板和桌面端内容区域适配
    @media (min-width: 768px) {
      padding-left: 60px;
      padding-right: 60px;
    }

    @media (min-width: 992px) {
      padding-left: 120px;
      padding-right: 120px;
    }

    @media (min-width: 1200px) {
      padding-left: 200px;
      padding-right: 200px;
      font-size: 18px;
    }
  }
}
</style>